class LocationsController {
  constructor(apiService) {
    this.apiService = apiService;
  }

  async getCountries({ q, limit } = {}) {
    const params = {};
    if (q) params.q = q;
    if (limit) params.limit = limit;
    const response = await this.apiService.get('/locations/countries', { params });
    return response.data;
  }

  async searchCities({ q, country, limit } = {}) {
    const params = {};
    if (q) params.q = q;
    if (country) params.country = country;
    if (limit) params.limit = limit;
    const response = await this.apiService.get('/locations/cities', { params });
    return response.data;
  }
}

export default LocationsController;
